export default __webpack_public_path__ + "static/media/thumbs-down-full.2de2c7d1.svg";